module.exports = __webpack_public_path__ + "img/illustration-login2-blue2.8da967f7.svg";